import React, { useState, useEffect } from "react";
import { useScreenSize, useCustomScreen } from "../Utils";

export default function BenefitsSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  return (
    <section id="services" className="services mt-3">
      <div className="container">
        <header className="section-header my-3">
          <h3
            style={{
              fontSize: is4kScreen
                ? "5.3rem"
                : isXxlScreen
                ? "2.8rem"
                : isXlScreen
                ? "2.6rem"
                : isIpadProPortrait
                ? "3rem"
                : isLargeScreen
                ? "2.4rem"
                : isMediumScreen
                ? "2.4rem"
                : isSmallScreen
                ? " 1.8rem"
                : "2rem",
            }}
          >
            We've been delivering value to customers since 2013
          </h3>
          <p
            className="mt-5"
            style={{
              fontSize: is4kScreen
                ? "4rem"
                : isXxlScreen
                ? " 2.5rem"
                : isXlScreen
                ? "2.6rem"
                : isLargeScreen
                ? "2.3rem"
                : "26px",
            }}
          >
            Benefits of our services
          </p>
        </header>
        <div className="row mb-5">
          <div
            className={`col-lg-${
              isIpadProPortrait ? "6" : "4"
            } col-md-6 d-flex align-items-stretch`}
          >
            <div className="icon-box mb-4 mb-md-0">
              <div className="mb-3 ">
                <img
                  src="/images/1380942151.png"
                  className="mb-4"
                  style={{
                    width: is4kScreen
                      ? "320px"
                      : isXxlScreen
                      ? "240px"
                      : isXlScreen
                      ? "220px"
                      : isLargeScreen
                      ? "155px"
                      : isMediumScreen
                      ? "170px"
                      : "145px",
                    height: is4kScreen
                      ? "280px"
                      : isXxlScreen
                      ? "210px"
                      : isXlScreen
                      ? "180px"
                      : isLargeScreen
                      ? "135px"
                      : isMediumScreen
                      ? "170px"
                      : "145px",
                  }}
                  alt="icon"
                />
              </div>
              <h4
                style={{
                  fontSize: is4kScreen
                    ? "3.5rem"
                    : isXxlScreen
                    ? "2rem"
                    : isXlScreen
                    ? "1.8rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1.5rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Grow Your Business
              </h4>
              <h6
                style={{
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.4rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Do more bids and claims:
              </h6>
              <p
                className="mb-4 py-2"
                style={{
                  fontSize: is4kScreen
                    ? "2.4rem"
                    : isXxlScreen
                    ? "1.4rem"
                    : isXlScreen
                    ? "1.3rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? "1.2rem"
                    : "18px",
                }}
              >
                By creating a preliminary estimate before you go out to the
                property, you'll be able to save time in the field.
              </p>
              <h6
                style={{
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "1.4rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Increase your closing rate:
              </h6>
              <p
                style={{
                  fontSize: is4kScreen
                    ? "2.4rem"
                    : isXxlScreen
                    ? "1.4rem"
                    : isXlScreen
                    ? "1.3rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? "1.2rem"
                    : "18px",
                }}
              >
                By having us (an independent third party) do the measuring, our
                accurate reports bring a higher credibility to your estimate.
              </p>
            </div>
          </div>
          <div
            className={`col-lg-${
              isIpadProPortrait ? "6" : "4"
            } col-md-6 d-flex align-items-stretch`}
          >
            <div className="icon-box">
              <div className="mb-3">
                <img
                  src="/images/1380942165.png"
                  className="mb-4"
                  style={{
                    width: is4kScreen
                      ? "320px"
                      : isXxlScreen
                      ? "240px"
                      : isXlScreen
                      ? "220px"
                      : isLargeScreen
                      ? "155px"
                      : isMediumScreen
                      ? "170px"
                      : "145px",
                    height: is4kScreen
                      ? "280px"
                      : isXxlScreen
                      ? "210px"
                      : isXlScreen
                      ? "180px"
                      : isLargeScreen
                      ? "135px"
                      : isMediumScreen
                      ? "170px"
                      : "145px",
                  }}
                  alt="icon"
                />
              </div>
              <h4
                style={{
                  fontSize: is4kScreen
                    ? "3.5rem"
                    : isXxlScreen
                    ? "2rem"
                    : isXlScreen
                    ? "1.8rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1.5rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Reduce Costs
              </h4>
              <h6
                style={{
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "1.4rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Lower Estimating Costs:
              </h6>
              <p
                className="mb-4"
                style={{
                  fontSize: is4kScreen
                    ? "2.4rem"
                    : isXxlScreen
                    ? "1.4rem"
                    : isXlScreen
                    ? "1.3rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? "1.2rem"
                    : "18px",
                }}
              >
                There is no such thing as a “Free Estimate” and your time is
                money. Reduce the time it takes to create an estimate and spend
                less time on the roof and more time in the living room closing
                the sale.
              </p>
              <h6
                style={{
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "1.4rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Reduce Waste:
              </h6>
              <p
                style={{
                  fontSize: is4kScreen
                    ? "2.4rem"
                    : isXxlScreen
                    ? "1.4rem"
                    : isXlScreen
                    ? "1.3rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.2rem"
                    : "18px",
                }}
              >
                Eliminate the “guestimate” and dial in the cost and use of
                materials with consistent and accurate reports.
              </p>
            </div>
          </div>
          <div
            className={`col-lg-${
              isIpadProPortrait ? "6" : "4"
            } col-md-6 d-flex align-items-stretch ${
              isIpadProPortrait ? "mt-4" : "mt-0"
            }`}
            style={{ height: isIpadProPortrait ? "50rem" : "" }}
          >
            <div className="icon-box  mt-4 mt-mb-4 mt-lg-0">
              <div className="mb-3">
                <img
                  src="/images/1380934567.png"
                  className=" mb-4"
                  style={{
                    width: is4kScreen
                      ? "320px"
                      : isXxlScreen
                      ? "240px"
                      : isXlScreen
                      ? "220px"
                      : isLargeScreen
                      ? "155px"
                      : isMediumScreen
                      ? "170px"
                      : "145px",
                    height: is4kScreen
                      ? "280px"
                      : isXxlScreen
                      ? "210px"
                      : isXlScreen
                      ? "180px"
                      : isLargeScreen
                      ? "135px"
                      : isMediumScreen
                      ? "170px"
                      : "145px",
                  }}
                  alt="icon"
                />
              </div>
              <h4
                style={{
                  fontSize: is4kScreen
                    ? "3.5rem"
                    : isXxlScreen
                    ? "2rem"
                    : isXlScreen
                    ? "1.8rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1.5rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Limit Liability
              </h4>
              <h6
                style={{
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "1.4rem"
                    : isIpadProPortrait
                    ? "1.5rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? " "
                    : isSmallScreen
                    ? ""
                    : "",
                }}
              >
                Reducing the number of times you have to get on a roof:
              </h6>
              <ul className="mb-4">
                <li
                  style={{
                    lineHeight: "30px",
                    paddingLeft: "30px",
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.4rem"
                      : isXlScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "18px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={
                      is4kScreen
                        ? "35"
                        : isXxlScreen
                        ? "22"
                        : isXlScreen
                        ? "20"
                        : isIpadProPortrait
                        ? "20"
                        : isLargeScreen
                        ? "16"
                        : "22"
                    }
                    height={
                      is4kScreen
                        ? "35"
                        : isXxlScreen
                        ? "22"
                        : isXlScreen
                        ? "20"
                        : isIpadProPortrait
                        ? "20"
                        : isLargeScreen
                        ? "16"
                        : "22"
                    }
                    fill="currentColor"
                    className="bi bi-check-circle"
                    viewBox="0 0 16 16"
                    style={{ color: "#57C0D1" }}
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                  </svg>{" "}
                  Increases safety
                </li>
                <li
                  style={{
                    lineHeight: "30px",
                    paddingLeft: "30px",
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.4rem"
                      : isXlScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "18px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={
                      is4kScreen
                        ? "35"
                        : isXxlScreen
                        ? "22"
                        : isXlScreen
                        ? "20"
                        : isIpadProPortrait
                        ? "20"
                        : isLargeScreen
                        ? "16"
                        : "22"
                    }
                    height={
                      is4kScreen
                        ? "35"
                        : isXxlScreen
                        ? "22"
                        : isXlScreen
                        ? "20"
                        : isIpadProPortrait
                        ? "20"
                        : isLargeScreen
                        ? "16"
                        : "22"
                    }
                    fill="currentColor"
                    className="bi bi-check-circle"
                    viewBox="0 0 16 16"
                    style={{ color: "#57C0D1" }}
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                  </svg>{" "}
                  Lowers risk of injury
                </li>
                <li
                  style={{
                    lineHeight: "30px",
                    paddingLeft: "30px",
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.4rem"
                      : isXlScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isMediumScreen
                      ? "1.2rem"
                      : "18px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={
                      is4kScreen
                        ? "35"
                        : isXxlScreen
                        ? "22"
                        : isXlScreen
                        ? "20"
                        : isIpadProPortrait
                        ? "20"
                        : isLargeScreen
                        ? "16"
                        : "22"
                    }
                    height={
                      is4kScreen
                        ? "35"
                        : isXxlScreen
                        ? "22"
                        : isXlScreen
                        ? "20"
                        : isIpadProPortrait
                        ? "20"
                        : isLargeScreen
                        ? "16"
                        : "22"
                    }
                    fill="currentColor"
                    className="bi bi-check-circle"
                    viewBox="0 0 16 16"
                    style={{ color: "#57C0D1" }}
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                  </svg>{" "}
                  Decreases insurance premiums
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
